import React from "react"
import { LayoutSidebar, Chart } from "../router"

export const Charts = () => {
  return (
    <>
      <LayoutSidebar>
        <Chart />
      </LayoutSidebar>
    </>
  )
}
